import { EmployerJPState } from '@restworld/utils-common';

export function getJPOnboardingFormLink({
  jpId,
  titleDescriptionSet,
  jpState,
}: {
  jpId: string;
  titleDescriptionSet?: boolean;
  jpState?: EmployerJPState;
}): string {
  let baseLink = `/employer/job-positions/onboarding?job_position_id=${jpId}`;
  switch (jpState) {
    case 'pending_approval':
      baseLink += `&step=review`;
      break;
    case 'draft':
      if (titleDescriptionSet) {
        baseLink += `&step=review`;
      }
      break;
    case 'open':
      // Editing an online JP reuses the onboarding wizard in "edit-online" mode:
      // land straight on the review step so the employer can jump to any section.
      baseLink += `&step=review`;
      break;
    default:
      break;
  }

  return baseLink;
}
